/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminGetAllJobs200Response,
  CandidateContactRequest,
  Job,
} from '../models/index';
import {
    AdminGetAllJobs200ResponseFromJSON,
    AdminGetAllJobs200ResponseToJSON,
    CandidateContactRequestFromJSON,
    CandidateContactRequestToJSON,
    JobFromJSON,
    JobToJSON,
} from '../models/index';

export interface CandidateApplyJobRequest {
    resume?: Blob;
    jobId?: number;
    email?: string;
    name?: string;
    phone?: string;
    coverLetter?: string;
}

export interface CandidateContactOperationRequest {
    body: CandidateContactRequest;
}

export interface CandidateGetAllJobsRequest {
    page?: number;
    limit?: number;
    status?: CandidateGetAllJobsStatusEnum;
    experienceLevel?: CandidateGetAllJobsExperienceLevelEnum;
    jobType?: CandidateGetAllJobsJobTypeEnum;
    title?: string;
    location?: string;
    domainId?: number;
    categoryId?: number;
    subCategoryId?: number;
}

export interface CandidateJobByIdRequest {
    id: number;
}

/**
 * 
 */
export class CandidateApi extends runtime.BaseAPI {

    /**
     * Applies for the job and sends email
     * API to apply for the job
     */
    async candidateApplyJobRaw(requestParameters: CandidateApplyJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['resume'] != null) {
            formParams.append('resume', requestParameters['resume'] as any);
        }

        if (requestParameters['jobId'] != null) {
            formParams.append('jobId', requestParameters['jobId'] as any);
        }

        if (requestParameters['email'] != null) {
            formParams.append('email', requestParameters['email'] as any);
        }

        if (requestParameters['name'] != null) {
            formParams.append('name', requestParameters['name'] as any);
        }

        if (requestParameters['phone'] != null) {
            formParams.append('phone', requestParameters['phone'] as any);
        }

        if (requestParameters['coverLetter'] != null) {
            formParams.append('coverLetter', requestParameters['coverLetter'] as any);
        }

        const response = await this.request({
            path: `/candidate/job/apply`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Applies for the job and sends email
     * API to apply for the job
     */
    async candidateApplyJob(requestParameters: CandidateApplyJobRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.candidateApplyJobRaw(requestParameters, initOverrides);
    }

    /**
     * Sends a contact message
     * API to contact us
     */
    async candidateContactRaw(requestParameters: CandidateContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling candidateContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/candidate/contact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CandidateContactRequestToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sends a contact message
     * API to contact us
     */
    async candidateContact(requestParameters: CandidateContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.candidateContactRaw(requestParameters, initOverrides);
    }

    /**
     * Fetch paginated job listings with filters for status, experience level, job type, and title. Returns full associations (domain, category, subcategory, company).
     * Get all job listings
     */
    async candidateGetAllJobsRaw(requestParameters: CandidateGetAllJobsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminGetAllJobs200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['experienceLevel'] != null) {
            queryParameters['experienceLevel'] = requestParameters['experienceLevel'];
        }

        if (requestParameters['jobType'] != null) {
            queryParameters['jobType'] = requestParameters['jobType'];
        }

        if (requestParameters['title'] != null) {
            queryParameters['title'] = requestParameters['title'];
        }

        if (requestParameters['location'] != null) {
            queryParameters['location'] = requestParameters['location'];
        }

        if (requestParameters['domainId'] != null) {
            queryParameters['domainId'] = requestParameters['domainId'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        if (requestParameters['subCategoryId'] != null) {
            queryParameters['subCategoryId'] = requestParameters['subCategoryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/job/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminGetAllJobs200ResponseFromJSON(jsonValue));
    }

    /**
     * Fetch paginated job listings with filters for status, experience level, job type, and title. Returns full associations (domain, category, subcategory, company).
     * Get all job listings
     */
    async candidateGetAllJobs(requestParameters: CandidateGetAllJobsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminGetAllJobs200Response> {
        const response = await this.candidateGetAllJobsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch a single job entry with associated entities
     * Get a job by ID
     */
    async candidateJobByIdRaw(requestParameters: CandidateJobByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Job>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling candidateJobById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/candidate/job/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobFromJSON(jsonValue));
    }

    /**
     * Fetch a single job entry with associated entities
     * Get a job by ID
     */
    async candidateJobById(requestParameters: CandidateJobByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Job> {
        const response = await this.candidateJobByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CandidateGetAllJobsStatusEnum = {
    Draft: 'DRAFT',
    Published: 'PUBLISHED',
    Closed: 'CLOSED'
} as const;
export type CandidateGetAllJobsStatusEnum = typeof CandidateGetAllJobsStatusEnum[keyof typeof CandidateGetAllJobsStatusEnum];
/**
 * @export
 */
export const CandidateGetAllJobsExperienceLevelEnum = {
    Entry: 'ENTRY',
    Mid: 'MID',
    Senior: 'SENIOR',
    Lead: 'LEAD',
    Executive: 'EXECUTIVE'
} as const;
export type CandidateGetAllJobsExperienceLevelEnum = typeof CandidateGetAllJobsExperienceLevelEnum[keyof typeof CandidateGetAllJobsExperienceLevelEnum];
/**
 * @export
 */
export const CandidateGetAllJobsJobTypeEnum = {
    Parttime: 'PARTTIME',
    Fulltime: 'FULLTIME',
    Freelance: 'FREELANCE',
    Contract: 'CONTRACT',
    Internship: 'INTERNSHIP'
} as const;
export type CandidateGetAllJobsJobTypeEnum = typeof CandidateGetAllJobsJobTypeEnum[keyof typeof CandidateGetAllJobsJobTypeEnum];
